module.exports = __webpack_public_path__ + "media/images/icons/flags/DE-cd7515611a2775d3c768b158d8a29e6e.svg";